import { IconButton } from '@/components/IconButton'
import cx from 'classnames'
import { NumericSpinnerInput } from '@/components/inputs/NumericSpinnerInput'
import styles from './ScopeChangeCustomItem.module.css'

export interface ScopeChangeCustomItemUpdateQuantityProps {
  name: string
  quantity: number
  hasQuantityError: boolean
  onRemove: () => unknown
  onQuantityChange: (value: number | null) => unknown
  removeButtonTestId?: string
  quantityInputTestId?: string
}

export function ScopeChangeCustomItemUpdateQuantity({
  name,
  quantity,
  hasQuantityError,
  onRemove,
  onQuantityChange,
  removeButtonTestId,
  quantityInputTestId,
}: ScopeChangeCustomItemUpdateQuantityProps) {
  return (
    <div className={styles.customItemInput}>
      <IconButton
        name="close"
        label="Remove item"
        className={styles.removeCustomItemButton}
        onPress={onRemove}
        testId={removeButtonTestId}
        size={24}
      />

      <div className={styles.textContainer}>
        <div className={styles.title}>{name}</div>
      </div>

      {/* This should always be 0 as it's a custom item. */}
      <div className={styles.currentQuantityContainer}>0</div>

      <NumericSpinnerInput
        min={1}
        value={quantity}
        onChange={onQuantityChange}
        invalid={hasQuantityError}
        testId={quantityInputTestId}
      />
    </div>
  )
}

export interface ScopeChangeCustomItemSelectionProps {
  name: string
  hasNameError: boolean
  onRemove: () => unknown
  onNameChange: (value: string) => unknown
  removeButtonTestId?: string
  nameInputTestId?: string
}

export function ScopeChangeCustomItemSelection({
  name,
  hasNameError,
  onRemove,
  onNameChange,
  removeButtonTestId,
  nameInputTestId,
}: ScopeChangeCustomItemSelectionProps) {
  return (
    <div className={styles.customItemInput}>
      <IconButton
        name="close"
        label="Remove item"
        className={styles.removeCustomItemButton}
        onPress={onRemove}
        testId={removeButtonTestId}
        size={24}
      />

      <input
        type="text"
        className={cx(
          styles.input,
          styles.customItemName,
          hasNameError && styles.hasError,
        )}
        placeholder="Enter your service type"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        data-test={nameInputTestId}
      />
    </div>
  )
}
